import React from 'react';
import "./EmptyTableDataInfographic.css"

const EmptyTableDataInfographic = ({...rest}) => {
    return (
        <div {...rest} className={"table-no-data"}>No data available</div>
    );
};

export default EmptyTableDataInfographic;